<template>
  <div class="hello">
    <div class="box">
      <h4>Gitlab dashboard</h4>

      <div class="form-group">
        <label class="zi-title zi-subtitle" for>Personal token</label>
        <zi-input class="w-full" v-model="token" placeholder="XXXXXXXXXXXX" />
        <p
          class="zi-subtitle"
        >Dit kan gevonden worden onder: User > Options > Access Token. Scope 'api' moet aangevinkt zijn anders hebben we geen toegang.</p>
      </div>

      <div class="form-group">
        <label class="zi-title zi-subtitle" for>Host</label>
        <zi-input class="w-full" v-model="gitlabhost" placeholder="e.g. https://gitlab.com" />
        <p class="zi-subtitle">Wanneer dit leeg gelaten wordt zal het https://gitlab.cube.nl worden.</p>
      </div>

      <div class="form-action">
        <span class="loader" v-if="isLoading">
          <zi-spinner></zi-spinner>
        </span>
        <zi-button
          :loading="isLoading"
          :disabled="!enableSubmit"
          @click="checkAccessToken"
          type="success"
        >verbinden</zi-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  computed: {
    enableSubmit() {
      return this.token && this.token.length === 20 && this.isLoading === false
    },
  },
  data: () => ({
    isLoading: false,
    token: '',
    gitlabhost: null,
  }),
  methods: {
    checkAccessToken() {
      this.isLoading = true

      this.$store.commit('RESET_PROJECTS')

      this.$store
        .dispatch('CHECKTOKEN', {
          host: this.gitlabhost,
          token: this.token,
        })
        .then(() => {
          this.$router.push({ name: 'select-project' })
        })
        .catch(err => {
          console.log('Catched an error', err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w-full {
  width: 100%;
}
.loader {
  margin-right: 10px;
}
</style>
